<template>
	<el-dialog
		title="选择要操作的店铺"
		:visible.sync="visible"
		center
		@close="handlerCancel"
	>
		<el-checkbox :indeterminate="isIndeterminate" v-model="checkAll" @change="handleCheckAllChange">全选</el-checkbox>
		<div style="margin: 15px 0;"></div>
		<el-checkbox-group v-model="shop_ids" @change="handleCheckedChange" style="display:flex;flex-flow: column wrap;flex-wrap: wrap;flex-direction: row;">
			<el-checkbox :label="item.shop_id" v-for="item in list" style="margin-top: 5px;width: 20%;">{{item.shop_name}}</el-checkbox>
		</el-checkbox-group>
		<span slot="footer" class="dialog-footer">
	      <el-button @click="handlerCancel">取 消</el-button>
	      <el-button type="primary" @click="handlerConfirm" :disabled="sending">确 定</el-button>
	    </span>
	</el-dialog>
</template>

<script>
import {mapActions} from "vuex";

export default {
	data() {
		return {
			buy_mode: 1,
			visible: false,
			list: [],
			listOld: [],
			params: {},
			func: {},
			callback: {},
			shop_ids: [],
			sending: false,
			checkAll: false,
			isIndeterminate: false,
		}
	},
	mounted() {
		this.getDdShopList({
			data: {
				page: 1,
				limit: 99999
			},
			success: (res) => {
				this.list = JSON.parse(JSON.stringify(res.data.list_data.data))
				this.listOld = JSON.parse(JSON.stringify(res.data.list_data.data))
				console.log(this.list)
			}
		})
	},
	methods: {
		...mapActions({
			getDdShopList:"ucenter/getDdShopList",
		}),
		handleCheckAllChange(val) {
			this.shop_ids = val ? this.listOld.map(item => item.shop_id) : [];
			this.isIndeterminate = false;
		},
		handleCheckedChange(value) {
			let checkedCount = value.length;
			this.checkAll = checkedCount === this.list.length;
			this.isIndeterminate = checkedCount > 0 && checkedCount < this.list.length;
		},
		open(params, func, callback) {
			this.params = params;
			this.func = func;
			this.callback = callback
			this.visible = true;
		},
		handlerConfirm() {
			if (this.sending) {
				return;
			}
			this.sending = true;
			this.func({
				data: Object.assign(this.params, {shop_ids: this.shop_ids}),
				success: (res) => {
					this.callback(res);
					this.visible = false;
					this.sending = false;
				},
			})
		},
		handlerCancel() {
			this.visible = false;
		}
	}
}
</script>

<style scoped>

</style>